/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Tasks_TitleInputs */

const en_pc_online_tasks_title = /** @type {(inputs: Pc_Online_Tasks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to do common jobs in PdfCraft Online`)
};

const zh_pc_online_tasks_title = /** @type {(inputs: Pc_Online_Tasks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 PdfCraft 在线版中完成常见任务`)
};

/**
* | output |
* | --- |
* | "How to do common jobs in PdfCraft Online" |
*
* @param {Pc_Online_Tasks_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_tasks_title = /** @type {((inputs?: Pc_Online_Tasks_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Tasks_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_tasks_title(inputs)
	return zh_pc_online_tasks_title(inputs)
});
export { pc_online_tasks_title as "pc.online.tasks_title" }